module.exports = __webpack_public_path__ + "static/media/1.317ecb01.png";